import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/theme.css';
import App from './App';
import { CampusProvider } from './contexts/CampusContext';

ReactDOM.render(
  <React.StrictMode>
    <CampusProvider>
    <App />
    </CampusProvider>
  </React.StrictMode>,
  document.getElementById('root')
); 